// extracted by mini-css-extract-plugin
export default {"root":"SuccessStateModal_root__mVGqY","icon":"SuccessStateModal_icon__gh3xA"};